import React, { Component } from "react"
import { Grid, Content } from "../components/Layout"
import Box from "../components/Box"
import Sidebar from "../components/Sidebar"
import Header from "../components/Header"
import ResponsiblesContent from '../components/ResponsiblesContent'
import News from "./News"

const {
  REACT_APP_DEFAULT_EMAIL,
  REACT_APP_CLIENT_ID
} = process.env
class Home extends Component {
  renderMailTo = email => {
    return (
      <a href={`mailto:${email}`}>
        {email}
      </a>
    )
  }

  renderDefaultWelcome = () => {
    return (
      <Box>
        <h2>Bem Vindo!</h2>
        <p>Essa plataforma foi pensada para você colaborador!</p>
        <p>
          Nela você encontrará todas as informações sobre os produtos
          químicos os quais utiliza em seu dia a dia.
        </p>
        <p>
          É de interesse de todos nós manter a segurança e o bom uso de
          todos os produtos, por isso utilize essa ferramenta sempre que
          precisar!
        </p>
        <p>
          Caso tenha alguma dúvida, entre em contato através do e-mail:{' '}
        </p>
        {this.renderMailTo(REACT_APP_DEFAULT_EMAIL)}
        <p>Muito obrigado!</p>
      </Box>
    )
  }

  renderHSLWelcome = () => {
    const email1 = 'segtrabelavista@hsl.org.br'
    const email2 = 'segtrabrasilia@hsl.org.br'
    return (
      <Box>
        <h2>Bem Vindo Colaborador!</h2>
        <p>Essa plataforma foi pensada para você!</p>
        <p>
          Aqui você encontrará informações sobre os produtos químicos que utiliza
          {' '} em seu dia a dia, tais como:
          {' '}<u>análise de incompatibilidade</u>, indicação de <u>produtos controlados</u>,
          {' '} panorama geral de <u>produtos da área por categoria</u> e <u>FDSs</u>.
        </p>
        <p>
          Para mais informações sobre a Gestão de Produtos Químicos, consulte o <strong>Manual de Segurança e Boas Práticas com Produtos Químicos</strong> disponível no <i>DMDocs</i> - <strong>CORP-MAN-SAUDE-001</strong>.
        </p>
        <p>
          <strong>Sua participação contribui para melhoria contínua dos processos de trabalho!</strong> <br />
          Caso tenha alguma dúvida, sugestão ou comentários, entre em contato através do e-mail:
          {' '} {this.renderMailTo(email1)}/ {this.renderMailTo(email2)}
        </p>
      </Box>
    )
  }

  renderWelcome = () => (
    REACT_APP_CLIENT_ID === 'hsl' ? this.renderHSLWelcome() : this.renderDefaultWelcome()
  )

  render() {
    const { menuItems = [], router } = this.props
    return (
      <Grid>
        <Header router={router} />
        <Sidebar menuItems={menuItems} router={router} />
        <Content>
          {this.renderWelcome()}
          <ResponsiblesContent />
          <News />
        </Content>
      </Grid>
    )
  }
}

export default Home



// WEBPACK FOOTER //
// ./src/containers/Home.js